import type { FormationSlotsQueryRequest } from 'types/api-responses';

interface BuildParams {
  developmentAreaId: number;
  typeCurveHeaderDetailsId?: number;
  inventoryWorkspaceId?: number;
  inventoryFormationPackageIds?: number[];
  formationName?: string;
  crossSectionEndPoints?: {
    start: { lat: number; lon: number };
    end: { lat: number; lon: number };
  };
  collectionIds?: number[];
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  text?: string;
}

export function buildFormationSlotsPayload({
  developmentAreaId,
  typeCurveHeaderDetailsId,
  inventoryWorkspaceId,
  inventoryFormationPackageIds,
  formationName,
  crossSectionEndPoints,
  collectionIds,
}: BuildParams): FormationSlotsQueryRequest {
  return {
    development_area_id: developmentAreaId,
    ...(typeCurveHeaderDetailsId !== undefined && {
      type_curve_header_details_id: typeCurveHeaderDetailsId,
    }),
    ...(inventoryWorkspaceId !== undefined && {
      inventory_workspace_id: inventoryWorkspaceId,
    }),
    ...(inventoryFormationPackageIds &&
      inventoryFormationPackageIds.length > 0 && {
        inventory_formation_package_ids: inventoryFormationPackageIds,
      }),
    ...(formationName !== undefined && {
      formation_name: formationName,
    }),
    ...(crossSectionEndPoints && {
      cross_section_end_points: crossSectionEndPoints,
    }),
    ...(collectionIds &&
      collectionIds.length > 0 && {
        collection_ids: collectionIds,
      }),
  };
}
